import { isShortTermRentalVertical } from "@/lib/vertical";

/** i18n namespace segment for `vertical.{prefix}.*` keys. */
export function verticalLocalePrefix(vertical: unknown): "fitness" | "str" {
  return isShortTermRentalVertical(vertical) ? "str" : "fitness";
}
